import React, { MutableRefObject, FC, UIEvent } from 'react';
import { map } from 'lodash';
import { CostCodeItem } from './item';
import { FieldArray, FieldArrayRenderProps } from 'formik';
import { Scalars } from '@bechtel/types';
import { CostCodesContainerBoxStyled, EmptyCostCodeContainerBoxStyled } from './styled';
import { Box, Text } from '@bechtel/gds';
import { Trans } from '@lingui/macro';
//@ts-ignore needed for declaration generation
import { ReactComponent as PackageIcon } from '@bechtel/client-assets/dist/images/view-details.svg';
import { useTimesheet } from '~/detail/context';

//Trigger build
export interface CostCodesProps {
  costCodeFieldArrayHelperRef: React.MutableRefObject<FieldArrayRenderProps | undefined>;
  collapseAll: boolean;
  collapseList: string[];
  setCollapseList: (list: string[]) => void;
  crewId: Scalars['ID'];
  costCodeListRef: MutableRefObject<HTMLDivElement[]>;
  onCostCodeListScroll: (e: UIEvent<HTMLDivElement, UIEvent>) => void;
  showDateHeader: boolean;
}

export const CostCodes: FC<CostCodesProps> = ({
  costCodeFieldArrayHelperRef,
  collapseAll,
  collapseList,
  setCollapseList,
  crewId,
  costCodeListRef,
  onCostCodeListScroll,
  showDateHeader,
}) => {
  const { hourTypes } = useTimesheet();
  return (
    <>
      <FieldArray name="timesheetCostCodes" validateOnChange={false}>
        {(arrayHelpers) => {
          costCodeFieldArrayHelperRef.current = arrayHelpers;
          return (
            <CostCodesContainerBoxStyled
              showDateHeader={showDateHeader}
              hourTypeCount={hourTypes ? hourTypes.length : 0}
            >
              {arrayHelpers.form.values.timesheetCostCodes.length > 0 ? (
                map(arrayHelpers.form.values.timesheetCostCodes, (timesheetCostCode, index) => {
                  return (
                    <CostCodeItem
                      key={timesheetCostCode.costCode.id}
                      timesheetCostCode={timesheetCostCode}
                      name={`timesheetCostCodes.${index}`}
                      collapseAll={collapseAll}
                      collapseList={collapseList}
                      setCollapseList={(list) => setCollapseList(list)}
                      crewId={crewId}
                      costCodeListRef={costCodeListRef}
                      onCostCodeListScroll={onCostCodeListScroll}
                    />
                  );
                })
              ) : (
                <EmptyCostCodeContainerBoxStyled data-testid="no-cost-codes-container">
                  <PackageIcon />
                  <Box mt={{ sm: '700' }} px={{ sm: '600' }}>
                    <Text family="graphik" color="grey.600">
                      <Trans>Please add Cost Code(s) to submit timesheet.</Trans>
                    </Text>
                  </Box>
                </EmptyCostCodeContainerBoxStyled>
              )}
            </CostCodesContainerBoxStyled>
          );
        }}
      </FieldArray>
    </>
  );
};
